module.exports = __webpack_public_path__ + "static/media/floor_n2.10159464.png";